import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';


export enum MoreIconVariant {
  DEFAULT = 'default',
  BUBBLE_MORE = 'bubble_more',
  VERTICAL = 'vertical',
}

interface IMoreIconProps extends IConDefaultType {
  variant?: MoreIconVariant;
}

function MoreIcon({ color, className, size = 24, rotate, flip, variant = MoreIconVariant.DEFAULT }: IMoreIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === MoreIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <circle cx="4" cy="12" r="2" transform="rotate(-90 4 12)" fill={color || EColorMap.gray_0} />
          <circle cx="12" cy="12" r="2" transform="rotate(-90 12 12)" fill={color || EColorMap.gray_0} />
          <circle cx="20" cy="12" r="2" transform="rotate(-90 20 12)" fill={color || EColorMap.gray_0} />
        </svg>
      )}
      {variant === MoreIconVariant.BUBBLE_MORE && (
        <svg viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 6C0 2.96243 2.46243 0.5 5.5 0.5H18.5C21.5376 0.5 24 2.96243 24 6C24 9.03757 21.5376 11.5 18.5 11.5H5.5C2.46243 11.5 0 9.03757 0 6Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.5 1.60769H5.5C3.0742 1.60769 1.10769 3.5742 1.10769 6C1.10769 8.4258 3.0742 10.3923 5.5 10.3923H18.5C20.9258 10.3923 22.8923 8.4258 22.8923 6C22.8923 3.5742 20.9258 1.60769 18.5 1.60769ZM5.5 0.5C2.46243 0.5 0 2.96243 0 6C0 9.03757 2.46243 11.5 5.5 11.5H18.5C21.5376 11.5 24 9.03757 24 6C24 2.96243 21.5376 0.5 18.5 0.5H5.5Z"
            fill="#D8D8D8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.76923 6C8.76923 6.75939 8.14932 7.375 7.38462 7.375C6.61991 7.375 6 6.75939 6 6C6 5.24061 6.61991 4.625 7.38462 4.625C8.14932 4.625 8.76923 5.24061 8.76923 6ZM13.3846 6C13.3846 6.75939 12.7647 7.375 12 7.375C11.2353 7.375 10.6154 6.75939 10.6154 6C10.6154 5.24061 11.2353 4.625 12 4.625C12.7647 4.625 13.3846 5.24061 13.3846 6ZM16.6154 7.375C17.3801 7.375 18 6.75939 18 6C18 5.24061 17.3801 4.625 16.6154 4.625C15.8507 4.625 15.2308 5.24061 15.2308 6C15.2308 6.75939 15.8507 7.375 16.6154 7.375Z"
            fill="#ADB0B8"
          />
        </svg>
      )}
      {variant === MoreIconVariant.VERTICAL && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="4" r="2" fill={color || '#ADB0B8'} />
          <circle cx="12" cy="12" r="2" fill={color || '#ADB0B8'} />
          <circle cx="12" cy="20" r="2" fill={color || '#ADB0B8'} />
        </svg>
      )}
    </i>
  );
}

export default MoreIcon;
